export enum FormFieldConditionAction {
  Show = 0,
  Hide = 1,
  Required = 2,
  Optional = 3
}
